import { Maybe } from 'maybeasy';
import { emptyFragment } from '../../../../../../../EmptyFragment';
import { handleDelete } from './Types';
import { Link } from '../../../../../../../Resource/Types';
import { T } from '../../../../../../../Translations';
import { observer } from 'mobx-react';
import { UploadImageStore } from '../UploadImageStore';

interface Props {
  previewUrl: Maybe<Link>;
  setPreviewUrl: (url: Maybe<Link>) => void;
  store: UploadImageStore;
}

function ImageReplaceDelete({ setPreviewUrl, previewUrl, store }: Props) {
  return previewUrl
    .map(() => (
      <div>
        <label
          htmlFor="upload-button"
          className="py-2.5 px-5 text-sm font-bold bg-white 
              rounded-md border border-teal-600 text-teal-600 
              cursor-pointer mr-4"
        >
          <T kind="Replace Image" />
        </label>
        <label
          onClick={() => handleDelete(setPreviewUrl, store)}
          className="py-2.5 px-5 
              text-sm font-bold 
              bg-white rounded-md border 
              border-red-700 text-red-700 cursor-pointer"
        >
          <T kind="Delete Image" />
        </label>
      </div>
    ))
    .getOrElse(emptyFragment);
}
export default observer(ImageReplaceDelete);
